export default function BottomBlur() {
  return (
    <div
      className="fixed bottom-0 left-0 w-full pointer-events-none"
      style={{
        height: '150px',
        zIndex: 30,
        background: 'linear-gradient(to bottom, transparent, #000)',
        WebkitMaskImage: 'linear-gradient(to top, #000 50%, transparent)',
        maskImage: 'linear-gradient(to top, #000 50%, transparent)',
        WebkitBackdropFilter: 'blur(4px)',
        backdropFilter: 'blur(4px)',
      }}
    />
  )
}
